// All resume content for Andres Campos
export const PROFILE = {
  name: "Andres Campos",
  firstName: "Andres",
  lastName: "Campos",
  title: "Commercial Permitting & Pre-Development",
  role: "Operations Lead & Project Manager",
  location: "Prosper, TX",
  phone: "(214) 901-4949",
  email: "jrecampos@outlook.com",
  linkedin: "https://www.linkedin.com/in/acampos/",
  website: "https://andrescampos.org/",
  websiteLabel: "AndresCampos.org",
  permitflow: "https://permitflow.com",
  permitflowLabel: "PermitFlow.com",
  preconteam: "PreConTeam Due Diligence",
  headshot: "/andres-headshot.png",
  resumeUrl: "/Andres-Campos-Resume.pdf",
};

export const HERO_LINES = ["ANDRES", "CAMPOS"];

export const INTRO =
  "Pre-development and commercial permitting leader with 10+ years managing due diligence, entitlements, and full-lifecycle permitting for 100+ commercial projects valued from $100K to $100M+ across all 50 states.";

export const STATS = [
  { value: 100, suffix: "+", label: "Projects Managed" },
  { value: 50, suffix: "", label: "States Covered" },
  { value: 10, suffix: "+", label: "Years Experience" },
  { value: 100, prefix: "$", suffix: "M+", label: "Max Project Value" },
];

export const DUAL = {
  left: {
    tag: "01 / Inside the Counter",
    title: "Municipal Plans Examiner",
    body: "Reviewed commercial and residential plans inside the City of Southlake and Town of Prosper building departments — evaluating IBC, IRC, IFC, zoning, and life-safety compliance. I know exactly what AHJs need to see, and why.",
  },
  right: {
    tag: "02 / Across the Counter",
    title: "Client-Side Expediter",
    body: "Now I navigate those same departments on behalf of national developers and brands. That dual perspective means fewer surprises, fewer resubmittals, and faster approvals for every project I take on.",
  },
};

export const MANIFESTO = [
  {
    num: "01",
    title: "Due Diligence First",
    body: "Every project begins with jurisdictional research, zoning analysis, and a clear permitting strategy — before design teams advance a single sheet.",
  },
  {
    num: "02",
    title: "Speak the AHJ's Language",
    body: "Years on the review side mean I anticipate comments before they're written. Packages are assembled to be approved, not corrected.",
  },
  {
    num: "03",
    title: "Coordinate the Whole Field",
    body: "Owner, GC, AOR/EOR, civil, fire, and vendors — I sit at the center, keeping every discipline aligned across the full approval lifecycle.",
  },
  {
    num: "04",
    title: "Deliver to C/O",
    body: "From pre-application to Certificate of Occupancy, I own the timeline. On schedule, on budget, across all 50 states.",
  },
];

export const EXPERTISE = [
  { title: "Pre-Development & Entitlements", span: "lg:col-span-2 lg:row-span-2", desc: "Zoning, land-use, rezoning, CUP/SUP, site plans, variances, platting, and Planning Commission / City Council hearings." },
  { title: "Full-Lifecycle Permitting", span: "lg:col-span-1", desc: "Due diligence through Certificate of Occupancy." },
  { title: "MHE Permitting", span: "lg:col-span-1", desc: "Conveyors, racking, mezzanines, sortation for warehouse & fulfillment." },
  { title: "Data Center Permitting", span: "lg:col-span-1", desc: "Complex multi-discipline industrial approvals." },
  { title: "AHJ & Regulatory Relations", span: "lg:col-span-1", desc: "DRC, P&Z, and municipal representation nationwide." },
  { title: "Fire & Life Safety", span: "lg:col-span-1", desc: "Sprinkler, high-piled storage, egress, alarm." },
  { title: "MEP & Civil / Site", span: "lg:col-span-1", desc: "Utilities, stormwater, right-of-way, grading." },
  { title: "Team Leadership", span: "lg:col-span-2", desc: "Building and mentoring permitting teams with AI-driven tools and continuous process improvement." },
];

export const EXPERIENCE = [
  {
    company: "PermitFlow",
    role: "Operations Lead | Project Manager",
    dates: "Oct 2024 — Present",
    location: "Dallas, TX (Remote)",
    points: [
      "Primary client contact for nationwide commercial development, managing the full permitting lifecycle from due diligence through Certificate of Occupancy.",
      "Managed permitting for 100+ commercial projects valued $100K to $100M+, supporting McDonald's, Amazon, IKEA, Tesla (AOR), Walmart, and more.",
      "Manage Material Handling Equipment (MHE) permitting for large-scale warehouse and fulfillment projects across Building, Structural, Electrical, Fire, and Life Safety disciplines.",
      "Lead and mentor permitting teams; leverage AI-driven tools to streamline workflows and reduce approval timelines.",
    ],
  },
  {
    company: "Coast to Coast Permitting",
    role: "Senior Project Manager | Founder",
    dates: "Jan 2015 — Paused",
    location: "Dallas, TX · CTCPermits.com",
    points: [
      "Founded a nationwide commercial permit expediting and pre-development consulting practice serving developers, contractors, and multi-site brands.",
      "Manage full entitlement coordination: zoning approvals, rezoning, CUP/SUP, site plans, variances, platting, development agreements, and design review.",
      "Comprehensive permitting across all commercial types — Ground-Up, TI, Shell & Core, MEP, Fire & Life Safety, ADA/TAS, Stormwater, Right-of-Way, and C/O.",
      "Extensive AHJ relationships across all 50 states and every major U.S. metro market.",
    ],
  },
  {
    company: "Parkway Construction & Architecture, LP",
    role: "Property Development Manager — Pre-Construction",
    dates: "Feb 2021 — Sep 2024",
    location: "Lewisville, TX (Hybrid)",
    points: [
      "Managed commercial development across 30+ active markets nationwide — schedules, budgets, and concurrent municipal plan reviews.",
      "Directed permitting, entitlement, and right-of-way approvals; represented national brands before DRCs and P&Z Commissions in FL, PA, OH, and CA.",
      "Prepared comprehensive pre-construction Site Investigation Reports (SIRs) with zoning analysis, code requirements, and critical-path schedules.",
    ],
  },
  {
    company: "Town of Prosper",
    role: "Plans Examiner",
    dates: "Jan 2019 — Jan 2021",
    location: "Prosper, TX",
    points: [
      "Performed comprehensive plan reviews ensuring compliance with IBC, IRC, IFC, IECC, and local zoning ordinances.",
      "Evaluated zoning setbacks, lot coverage, height, easements, and floodplain; calculated permit valuations and impact fees.",
    ],
  },
  {
    company: "City of Southlake",
    role: "Plans Examiner",
    dates: "Jan 2016 — Jan 2019",
    location: "Southlake, TX",
    points: [
      "Performed residential and commercial plan reviews for projects up to 25,000+ SF against IBC, IRC, IFC, and local ordinances.",
      "Guided contractors and developers through applications, revisions, inspections, and C/O; maintained data in EnerGov and Esri GIS.",
    ],
  },
];

export const CLIENTS = [
  "McDonald's", "Amazon", "IKEA", "Walmart", "Tesla", "Dick's Sporting Goods", "Fabletics", "Toll Brothers",
];

export const MARKETS = [
  "Dallas–Fort Worth", "Houston", "Austin", "Los Angeles", "Sacramento", "San Diego",
  "Miami-Dade", "Tampa", "Atlanta", "Charlotte", "Nashville", "Chicago",
  "Phoenix", "Las Vegas", "Denver", "Seattle", "Portland", "New York", "Philadelphia",
];

export const EDUCATION = [
  { degree: "Bachelors Degree — Business Administration", school: "East Texas A&M University, Commerce, TX" },
  { degree: "Business Marketing Coursework", school: "University of Texas at Dallas" },
  { degree: "Associate's Degree", school: "Collin County Community College" },
];

// NOTE: Sample placeholder testimonials — swap with real client quotes/attributions.
export const TESTIMONIALS = [
  {
    quote:
      "Andres flagged code issues before the city ever did. His plan packages get approved the first time — that's rare and it saves us weeks.",
    name: "Director of Development",
    role: "National QSR Brand",
  },
  {
    quote:
      "Having someone who's actually sat on the review side is a different level. He knows what each AHJ needs and gets us straight to a clean approval.",
    name: "VP, Pre-Construction",
    role: "Multi-Site Retail Developer",
  },
  {
    quote:
      "Our MHE and high-piled storage permitting across three states was seamless. Andres coordinated every trade and kept the whole schedule on track.",
    name: "Sr. Project Manager",
    role: "Fulfillment & Logistics",
  },
  {
    quote:
      "Clear due-diligence reports, honest timelines, and relentless follow-through. Andres is the first call for any complex multi-jurisdiction project.",
    name: "Principal",
    role: "Commercial GC",
  },
  {
    quote:
      "He turned a stalled entitlement into an approved site plan in one hearing cycle. Deep AHJ relationships and zero surprises.",
    name: "Managing Partner",
    role: "Mixed-Use Development Group",
  },
];


export const PROJECT_TYPES = [
  "Pre-Development Consulting",
  "Entitlements & Zoning",
  "Full-Lifecycle Permitting",
  "MHE / Warehouse Permitting",
  "Data Center Permitting",
  "Full-Time Opportunity",
  "Other",
];
